const a = (t) => {
  const n = /[^a-zA-Z0-9]/, e = t.split(" ").filter((s) => s.length > 0 && !n.test(s[0]));
  if (e.length === 0)
    return "";
  const i = e[0][0].toUpperCase(), l = e.length > 1 ? e[e.length - 1][0].toUpperCase() : "";
  return i + l;
}, o = (t) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t), g = (t, n = (e) => e) => {
  if (t.length === 0)
    return "";
  if (t.length === 1)
    return n(t[0]);
  const e = n(t.pop());
  return `${t.map(n).join(", ")} or ${e}`;
};
export {
  g as arrayToCommaSeparatedString,
  a as getNameInitials,
  o as isValidEmail
};
//# sourceMappingURL=text.es.js.map
